/*
<template>
  <div class="tc-container">
    <div class="tc-chart">
      <div class="chartTitle">
        <p>
          客流饱和密度
          <span style="color: #59b0f9">67%</span>
        </p>
        <p>
          近一小时流量
          <span style="color: #feb72d">643</span>
          人
        </p>
      </div>
      <div class="myChart" ref="myChart" />
    </div>
  </div>
</template>

<script>
  export default {
    name: 'early-warning',
    data() {
      return {
        actvIndex: 1,
      }
    },
    mounted() {
      this.init()
    },
    methods: {
      init() {
        let chartDom = this.$refs.myChart
        let myChart = this.$echarts.init(chartDom)
        // 绘制左侧面
        const CubeLeft = this.$echarts.graphic.extendShape({
          shape: {
            x: 0,
            y: 0,
          },
          buildPath: function (ctx, shape) {
            // 会canvas的应该都能看得懂，shape是从custom传入的
            const xAxisPoint = shape.xAxisPoint
            console.log(shape)
            const c0 = [shape.x + 0, shape.y]
            const c1 = [shape.x - 12, shape.y - 6]
            const c2 = [xAxisPoint[0] - 12, xAxisPoint[1] - 13]
            const c3 = [xAxisPoint[0] + 0, xAxisPoint[1]]
            ctx
              .moveTo(c0[0], c0[1])
              .lineTo(c1[0], c1[1])
              .lineTo(c2[0], c2[1])
              .lineTo(c3[0], c3[1])
              .closePath()
          },
        })
        // 绘制右侧面
        const CubeRight = this.$echarts.graphic.extendShape({
          shape: {
            x: 0,
            y: 0,
          },
          buildPath: function (ctx, shape) {
            const xAxisPoint = shape.xAxisPoint
            const c1 = [shape.x + 0, shape.y]
            const c2 = [xAxisPoint[0] + 0, xAxisPoint[1]]
            const c3 = [xAxisPoint[0] + 10, xAxisPoint[1] - 15]
            const c4 = [shape.x + 10, shape.y - 15]
            ctx
              .moveTo(c1[0], c1[1])
              .lineTo(c2[0], c2[1])
              .lineTo(c3[0], c3[1])
              .lineTo(c4[0], c4[1])
              .closePath()
          },
        })
        // 绘制顶面
        const CubeTop = this.$echarts.graphic.extendShape({
          shape: {
            x: 0,
            y: 0,
          },
          buildPath: function (ctx, shape) {
            const c1 = [shape.x + 0, shape.y]
            const c2 = [shape.x + 10, shape.y - 15] //右点
            const c3 = [shape.x - 0, shape.y - 20]
            const c4 = [shape.x - 12, shape.y - 6]
            ctx
              .moveTo(c1[0], c1[1])
              .lineTo(c2[0], c2[1])
              .lineTo(c3[0], c3[1])
              .lineTo(c4[0], c4[1])
              .closePath()
          },
        })
        this.$echarts.graphic.registerShape('CubeLeft', CubeLeft)
        this.$echarts.graphic.registerShape('CubeRight', CubeRight)
        this.$echarts.graphic.registerShape('CubeTop', CubeTop)
        let option = (option = {
          backgroundColor: '',
          title: {
            text: '',
            top: 32,
            left: 18,
            textStyle: {
              color: '#00F6FF',
              fontSize: 24,
            },
          },
          grid: {
            left: 0,
            right: 0,
            bottom: '15%',
            top: '5%',
            containLabel: true,
          },
          xAxis: {
            type: 'category',
            data: [
              '01时',
              '02时',
              '03时',
              '04时',
              '05时',
              '06时',
              '07时',
              '08时',
              '09时',
            ],
            axisLine: {
              show: true,
              lineStyle: {
                color: 'white',
              },
            },
            offset: 5,
            axisTick: {
              show: false,
              length: 9,
              alignWithLabel: true,
              lineStyle: {
                color: '#7DFFFD',
              },
            },
            axisLabel: {
              fontSize: 10,
            },
          },
          yAxis: {
            type: 'value',
            axisLine: {
              show: false,
              lineStyle: {
                color: 'white',
              },
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: '#585C5D',
              },
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              show: false,
            },
            boundaryGap: ['20%', '20%'],
          },
          series: [
            {
              type: 'custom',
              renderItem: (params, api) => {
                const location = api.coord([api.value(0), api.value(1)])
                return {
                  type: 'group',
                  children: [
                    {
                      type: 'CubeLeft',
                      shape: {
                        api,
                        xValue: api.value(0),
                        yValue: api.value(1),
                        x: location[0],
                        y: location[1],
                        xAxisPoint: api.coord([api.value(0), 0]),
                      },
                      style: {
                        fill: this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                          {
                            offset: 0,
                            color: '#0E8CF8',
                          },
                          {
                            offset: 1,
                            color: '#2ECBF8',
                          },
                        ]),
                      },
                    },
                    {
                      type: 'CubeRight',
                      shape: {
                        api,
                        xValue: api.value(0),
                        yValue: api.value(1),
                        x: location[0],
                        y: location[1],
                        xAxisPoint: api.coord([api.value(0), 0]),
                      },
                      style: {
                        fill: this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                          {
                            offset: 0,
                            color: '#0E8CF8',
                          },
                          {
                            offset: 1,
                            color: '#2ECBF8',
                          },
                        ]),
                      },
                    },
                    {
                      type: 'CubeTop',
                      shape: {
                        api,
                        xValue: api.value(0),
                        yValue: api.value(1),
                        x: location[0],
                        y: location[1],
                        xAxisPoint: api.coord([api.value(0), 0]),
                      },
                      style: {
                        fill: this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                          {
                            offset: 0,
                            color: '#0E8CF8',
                          },
                          {
                            offset: 1,
                            color: '#2ECBF8',
                          },
                        ]),
                      },
                    },
                  ],
                }
              },
              data: [
                2012, 1230, 3790, 2349, 1654, 1230, 3790, 2349, 1654, 3790,
                2349, 1654,
              ],
            },
          ],
        })
        myChart.setOption(option)
      },
      handSelect(i) {
        this.actvIndex = i
      },
    },
  }
</script>

<style lang="scss" scoped>
  .tc-container {
    width: 100%;

    ul {
      list-style: none;
      display: flex;
      justify-content: flex-end;
      color: #15a983;
      cursor: pointer;

      li {
        margin-right: 30px;
        white-space: nowrap;
      }

      .is-active {
        border-bottom: 1px solid #ffc600;
        padding-bottom: 7px;
        position: relative;
        color: #fff;

        &::after {
          content: '';
          width: 0;
          height: 0;
          border-bottom: 5px solid #ffc600;
          border-left: 5px solid transparent;
          border-right: 5px solid transparent;
          position: absolute;
          bottom: 0px;
          left: 37%;
        }
      }
    }

    .tc-chart {
      width: 100%;
      height: 150px;
      margin: 0 auto;
      .chartTitle {
        display: flex;
        align-items: center;
        justify-content: space-around;
        color: #e6e6e6;
        font-size: 14px;
        span {
          font-size: 26px;
        }
      }
      .myChart {
        width: 100%;
        height: 150px;
      }
    }
  }
</style>
